import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import noZoomConfig from "pro-features/components/Chart/src/configs/zoom/noZoomConfig";
import { ChartTooltip } from "app/components/React/MarketingChannelsDistribution/ChartTooltip";
import ReactDOMServer from "react-dom/server";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import tooltipContainerConfig from "pro-features/components/Chart/src/configs/tooltip/tooltipContainerConfig";

export const getChartConfig = (chartData, enableTooltip = true) => {
    return combineConfigs(null, [
        noLegendConfig,
        noZoomConfig,
        tooltipContainerConfig,
        {
            chart: {
                backgroundColor: null,
            },
            xAxis: {
                visible: false,
            },
            yAxis: {
                visible: false,
            },
            series: [
                {
                    data: chartData,
                    animation: false,
                },
            ],
            plotOptions: {
                series: {
                    pointWidth: 8,
                },
            },
            tooltip: {
                enabled: enableTooltip,
                outside: true,
                useHTML: true,
                shared: true,
                formatter: ({ chart }) => {
                    return ReactDOMServer.renderToString(<ChartTooltip chart={chart} />);
                },
                style: {
                    width: 200,
                },
                positioner: () => {
                    const { pageX, pageY } = (window as any).event;
                    const SMALL_OFFSET = 200;
                    const tooltipPosition = {
                        x: pageX - SMALL_OFFSET,
                        y: pageY,
                    };
                    return tooltipPosition;
                },
            },
        },
    ]);
};
